export const FilterType = {
  Search: "search",
  Select: "select",
  MultiSelect: "multi-select",
  DateRange: "date-range",
} as const;

export type FilterType = (typeof FilterType)[keyof typeof FilterType];

export type SelectFilterOption = { value: unknown; title: string };

/** Options from API (apiPath) or static list. */
export type FilterOptionsSource =
  | { apiPath: string }
  | { options: SelectFilterOption[] }
  | { options: () => Promise<SelectFilterOption[]> };

export type SetFilterFn = (key: string, value: unknown) => void;

type BaseFilter = {
  /** Persistence / query key for this filter. */
  key: string;
  /** i18n key for the filter label. */
  label: string;
  placeholder?: string;
  syncRouteQuery?: boolean;
};

export type SearchFilter = BaseFilter & {
  filterType: "search";
};

export type SelectFilter = BaseFilter & {
  filterType: "select";
  multiple?: boolean;
  showClearAllInMenu?: boolean;
  minSelected?: number;
  searchable?: boolean;
} & FilterOptionsSource;

export type DateRangeFilter = BaseFilter & {
  filterType: "date-range";
  handler: (range: string[], setFilter: SetFilterFn) => void;
};

export type Filter = SearchFilter | SelectFilter | DateRangeFilter;
